import React from 'react';
import { Box, Typography, CircularProgress, Alert, AlertTitle, IconButton, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

export const LoadingState = ({ message }) => (
  <Box sx={{ textAlign: 'center', py: 8 }}>
    <CircularProgress size={40} />
    <Typography variant="body1" color="text.primary">{message}</Typography>
  </Box>
);

export const ErrorState = ({ title, message, onRetry }) => (
  <Box sx={{ py: 8, textAlign: 'center' }}>
    <Alert
      severity="error"
      sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}
      action={
        <IconButton color="inherit" size="small" onClick={onRetry}>
          <RefreshIcon />
        </IconButton>
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
    <Button variant="contained" startIcon={<RefreshIcon />} onClick={onRetry}>
      Try Again
    </Button>
  </Box>
);

export const EmptyState = ({ title, subtitle }) => (
  <Box sx={{ textAlign: 'center', py: 8 }}>
    <Typography variant="h6" color="text.primary" gutterBottom>{title}</Typography>
    <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
  </Box>
);
